/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAllergiesNoted = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 8.174c.332.117.637.289.903.508l.925-.924 1.414 1.414-1.29 1.29c.03.175.048.354.048.538h2v2h-2c0 .183-.017.363-.049.537l1.291 1.291-1.414 1.414-.925-.925c-.266.22-.571.39-.903.508V17h-2v-1.175a2.991 2.991 0 0 1-.904-.508l-.924.925-1.414-1.414 1.29-1.29A3.018 3.018 0 0 1 9 13H7v-2h2c0-.184.016-.363.048-.538l-1.29-1.29 1.414-1.414.924.924c.266-.22.572-.39.904-.508V7h2zM12 10a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1z" />
        <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16z" />
      </g>
    </g>
  </Icon>
);
export { SvgAllergiesNoted as AllergiesNoted };
